import React__default from 'react';
import { Image } from '../Image/Image.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const LazyImage = (_a) => {
  var _b = _a, {
    src,
    onClick,
    className,
    contain = false,
    cover = false,
    aspectRatio = 1,
    height,
    width,
    alt = "",
    hover = "",
    borderRadius = 0,
    imageWidth,
    thumbnail,
    decoding = "async",
    lazy = true,
    fetchPriority = "low"
  } = _b, props = __objRest(_b, [
    "src",
    "onClick",
    "className",
    "contain",
    "cover",
    "aspectRatio",
    "height",
    "width",
    "alt",
    "hover",
    "borderRadius",
    "imageWidth",
    "thumbnail",
    "decoding",
    "lazy",
    "fetchPriority"
  ]);
  return /* @__PURE__ */ React__default.createElement(Image, __spreadValues({
    src,
    decoding,
    alt,
    hover,
    onClick,
    className,
    height,
    aspectRatio,
    width,
    thumbnail,
    borderRadius,
    objectFit: cover ? "cover" : contain ? "contain" : "inherit",
    googleImageParams: { width: imageWidth },
    fetchpriority: fetchPriority,
    lazy
  }, props));
};

export { LazyImage };
